import React from "react";
import { Button, Container, Nav, Row, Col, Badge } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";

import ItemList from "../../Components/ItemList";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import RecordTransaction from "./RecordTransaction";
import NavBar from "../../Components/NavBar";
import { getFullName } from "../../../Modules/utils/fullname";
import RenderAmount from "../../../Components/etc/RenderAmount";
import {
  formatTypeLabel,
  isRecordAllowedForTrType,
  TRANSACTION_TYPES,
} from "./FormSteps/SelectTransactionType";
import DynamicFilters from "./DynamicFilters";
import TransactionDetails from "./TransactionDetails";
import { dtFrmtS1 } from "../../../Modules/utils/etc";

const SCREEN_NAME = "TRANSACTIONS_SCREEN";

const ROW_CONFIG = {
  style: ({ index, item }) => {
    return item.status === "pending"
      ? { background: "#fff7c1" }
      : item.status === "rejected"
        ? { background: "#f9ac97ff" }
        : {};
  },
};

const COLUMN_CONFIG = {
  all: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "transactionType",
      label: "Type",
      render: ({ item }) => formatTypeLabel(item.transactionType),
    },
    {
      value: "agent",
      label: "Field Executive",
      render: ({ item }) => getFullName(item.relatedUser),
    },
    {
      value: "totalAmount",
      label: "Total Amount",
      render: ({ item }) => (
        <RenderAmount
          style={{
            color: [
              "user_payout",
              "office_expense",
              "owner_collection",
            ].includes(item.transactionType)
              ? "red"
              : ["user_payin", "agent_report"].includes(item.transactionType)
                ? "green"
                : "black",
          }}
          value={item.totalAmount}
        />
      ),
    },
    {
      value: "totalCod",
      label: "COD Amount",
      render: ({ item }) => <RenderAmount value={item.cod?.totalCOD} />,
    },
    {
      value: "rtoLoss",
      label: "RTO Loss",
      render: ({ item }) => (
        <RenderAmount value={item.rtoLoss?.total?.amount} />
      ),
    },
    {
      value: "codCurrent",
      label: "Balance Due (current)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.current, "cod"),
    },
    {
      value: "codTotal",
      label: "Balance Due (total)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.total, "cod"),
    },

    {
      value: "deliveryCount",
      label: "Delivered",
      render: ({ item }) => (
        <div className="numeric">{item.cod?.deliveryCount}</div>
      ),
    },
    {
      value: "pickupCount",
      label: "Picked",
      render: ({ item }) => (
        <div className="numeric">{item.cod?.pickupCount}</div>
      ),
    },
    {
      value: "commCurrent",
      label: "Commission (cur)",
      render: ({ item }) =>
        renderBalance(item.commissionBalance?.current, "commission"),
    },
    {
      value: "commTotal",
      label: "Commission (total)",
      render: ({ item }) =>
        renderBalance(item.commissionBalance?.total, "commission"),
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
    {
      value: "txnId",
      label: "Txn Id",
      render: ({ item }) => (
        <span className="text-muted mono">
          {item?._id?.toString().slice(-6)}
        </span>
      ),
    },
  ],

  agent_report: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "agent",
      label: "Field Executive",
      render: ({ item }) => getFullName(item.relatedUser),
    },
    {
      value: "totalAmount",
      label: "COD Amount",
      render: ({ item }) => <RenderAmount value={item.cod?.totalCOD} />,
    },
    {
      value: "codPaidByAgent",
      label: "Paid Amount",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "codCurrent",
      label: "Balance Due (current)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.current, "cod"),
    },
    {
      value: "codTotal",
      label: "Balance Due (total)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.total, "cod"),
    },

    {
      value: "deliveryCount",
      label: "Delivered",
      render: ({ item }) => (
        <div className="numeric">{item.cod?.deliveryCount || 0}</div>
      ),
    },
    {
      value: "pickupCount",
      label: "Picked",
      render: ({ item }) => (
        <div className="numeric">{item.cod?.pickupCount || 0}</div>
      ),
    },
    {
      value: "commCurrent",
      label: "Commission (cur)",
      render: ({ item }) =>
        renderBalance(item.commissionBalance?.current, "commission"),
    },
    {
      value: "commTotal",
      label: "Commission (total)",
      render: ({ item }) =>
        renderBalance(item.commissionBalance?.total, "commission"),
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],

  user_payin: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "agent",
      label: "Field Executive",
      render: ({ item }) => getFullName(item.relatedUser),
    },
    {
      value: "totalAmount",
      label: "Pay In",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "rtoLoss",
      label: "RTO Loss",
      render: ({ item }) => (
        <RenderAmount value={item.rtoLoss?.total?.amount} />
      ),
    },
    {
      value: "rtoLossList",
      label: "RTO Loss Items",
      render: ({ item }) =>
        item.rtoLossList?.map((x) => `${x.id}(₹${x.amount})`).join(", "),
    },
    {
      value: "balanceDue",
      label: "Balance Due (total)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.total, "cod"),
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],

  user_payout: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "agent",
      label: "Field Executive",
      render: ({ item }) => getFullName(item.relatedUser),
    },
    {
      value: "totalAmount",
      label: "Pay Out",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "codTotal",
      label: "Balance Due (total)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.total, "cod"),
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],

  office_expense: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "transactionItem",
      label: "Category",
    },
    {
      value: "totalAmount",
      label: "Amount",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],

  owner_collection: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "totalAmount",
      label: "Amount",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "status",
      label: "Status",
      render: ({ item }) => {
        const s = item.status;
        const map = {
          approved: { text: "Approved", class: "text-success fw-bold" },
          pending: { text: "Pending", class: "text-warning fw-bold" },
          rejected: { text: "Rejected", class: "text-danger fw-bold" },
        };

        const v = map[s] || { text: s, class: "" };

        return <span className={v.class}>{v.text}</span>;
      },
    },
    {
      value: "totalCod",
      label: "Total COD",
      render: ({ item }) => (
        <RenderAmount value={item.meta?.overall?.totalCOD} />
      ),
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],

  adjustment: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "totalAmount",
      label: "Adjusted Amount",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],
};

// ---------- Helpers (UI small utilities) ----------
function renderBalance(value, kind) {
  // undefined -> show dash
  if (typeof value === "undefined" || value === null)
    return <span className="text-muted">—</span>;

  return <RenderAmount value={value} />;
}

// note rendering uses closure handlers defined later; placeholders here to keep column defs readable
let _noteEditor = null;
function renderEditableNote(item) {
  // item may contain note string
  const note = item.note || "";
  // show small edit icon (unicode pencil) — clicking calls _noteEditor(item)
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ flex: 1, whiteSpace: "nowrap" }}>
        {note || <span className="text-muted">—</span>}
      </div>
      <div
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          _noteEditor && _noteEditor(item);
        }}
      >
        <small className="text-primary">✎</small>
      </div>
    </div>
  );
}

// ---------- Component ----------
class TransactionsScreenOffice extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      transactions: [],
      triggerReload: 0,
      query: {},
      additionalFilter: {
        transactionType: undefined,
      },
      deleting: false,
      loadingAgents: false,
    };

    this.additionalQueries = null;

    // bind note editor so renderEditableNote can call it
    _noteEditor = this.openNoteEditor.bind(this);
  }

  componentDidMount() {
    this.onMount();
    if (!this.props.agents?.length) this.loadAgents();
  }

  async loadAgents() {
    try {
      this.setAsyncState({ loadingAgents: true });
      // Reuse head-office user endpoint for role=agent
      const res = await api.get("v1/office/user", {
        queryStr: JSON.stringify({ where: { role: "agent" }, limit: 0 }),
      });
      const agents = res?.users || [];
      this.props.setScreenState({ agents }, false, "AGENTS_SCREEN");
    } catch (e) {
      this.setAsyncState({ error: e.message });
    } finally {
      this.setAsyncState({ loadingAgents: false });
    }
  }

  // fetch transactions from backend and map to current shape
  async retriveData(query) {
    // pass query directly to backend (ItemList handles stringify)
    const { transactions } = await api.get("v1/office/transaction", query);
    if (!Array.isArray(transactions)) return [];

    return transactions.map((item) => {
      // normalize agent/exposed fields for compatibility with older UI
      const normalized = {
        ...item,
        relatedUser: item.relatedUser || item.agent || null, // fallback
      };

      // compute RTO stats from cod.rtoLossList (if present)
      const rtoList = item.rtoLossList || [];
      let rtoPaid = 0,
        rtoPaidAmount = 0,
        rtoUnpaid = 0,
        rtoUnpaidAmount = 0,
        rtoLossAmount = 0;
      if (Array.isArray(rtoList)) {
        for (const r of rtoList) {
          const amt = parseFloat(r.amount) || 0;
          rtoLossAmount += amt;
          if (r.status === "paid") {
            rtoPaid += 1;
            rtoPaidAmount += amt;
          } else {
            rtoUnpaid += 1;
            rtoUnpaidAmount += amt;
          }
        }
      }

      return {
        ...normalized,
        // expose simpler rtoLoss shape for older columns
        rtoLoss: {
          total: { count: rtoList.length, amount: rtoLossAmount },
          paid: { count: rtoPaid, amount: rtoPaidAmount },
          unpaid: { count: rtoUnpaid, amount: rtoUnpaidAmount },
        },
      };
    });
  }

  async setItems(items) {
    if (this.props.contentOnly) this.setAsyncState({ transactions: items });
    else this.props.setScreenState({ transactions: items });
  }

  getItems() {
    if (this.props.contentOnly) return this.state.transactions;
    else return this.props.transactions;
  }

  onNewTransaction(item) {
    // refresh list
    this.setAsyncState({
      triggerReload: Date.now(),
    });
    this.props.onNewTransaction?.(item);
  }

  handleRecordTransaction() {
    this.setAsyncState({
      visibleModal: "recordTransaction",
      modalData: {
        transaction: {
          transactionType: this.state.additionalFilter?.transactionType,
        },
      },
    });
  }

  handleTypeChange(type) {
    this.setItems([]);
    this.setState((s) => ({
      additionalFilter: {
        ...(s.additionalFilter?.date ? { date: s.additionalFilter.date } : {}),
        ...(type === "all" ? {} : { transactionType: type }),
      },

      triggerReload: Date.now(),
    }));
  }

  async handleDelete(transaction) {
    try {
      if (this.state.deleting) return null;

      if (
        window.confirm(
          `Are you sure you want to delete this ${formatTypeLabel(
            transaction.transactionType,
          )} transaction ? This action is not reversible.`,
        )
      ) {
        this.setAsyncState({ deleting: true });
        await api.delete("v1/office/transaction/" + transaction._id);

        this.setAsyncState({
          visibleModal: null,
          modalData: null,
          triggerReload: Date.now(),
          deleting: false,
        });
      }
    } catch (e) {
      this.setAsyncState({ deleting: false });
      console.error(e.message);
      window.alert("Error deleting transaction: " + e.message);
    }
  }

  // ===== Inline Note Editor (quick flow) =====
  async openNoteEditor(transaction) {
    try {
      const currentNote = transaction?.note || "";
      const updated = window.prompt(
        `Edit note for transaction (${formatTypeLabel(
          transaction.transactionType,
        )}):`,
        currentNote,
      );
      // user pressed cancel
      if (updated === null) return;

      // If unchanged, no update
      if (updated === currentNote) return;

      // patch note
      await api.patch(`v1/office/transaction/${transaction._id}/note`, {
        note: updated,
      });

      // refresh
      this.setAsyncState({ triggerReload: Date.now() });
    } catch (err) {
      console.error("Note update failed:", err);
      window.alert("Failed to update note: " + (err.message || err));
    }
  }

  buildAdditionalWhere(additionalFilter = {}) {
    const rtoId = additionalFilter["rtoLossList.id"];

    if (typeof rtoId === "string" && rtoId.length > 3) {
      return {
        "rtoLossList.id": rtoId,
      };
    }

    return additionalFilter;
  }

  render() {
    const { visibleModal, modalData, triggerReload, additionalFilter } =
      this.state;

    const selectedType = this.state.additionalFilter?.transactionType || "all";
    const columns = COLUMN_CONFIG[selectedType] || COLUMN_CONFIG.all;

    const content = (
      <div>
        {/* Header */}
        <div className="pagetitlebar mb-3 d-flex justify-content-between align-items-center">
          <div className="left">
            <div className="title">Transactions</div>
          </div>

          <div className="right d-flex gap-2 align-items-center">
            <Button
              variant="secondary"
              onClick={() => this.setAsyncState({ triggerReload: Date.now() })}
            >
              Reload
            </Button>

            {(selectedType === "all" ||
              isRecordAllowedForTrType(selectedType)) && (
              <Button
                onClick={() => this.handleRecordTransaction()}
                disabled={this.props.account?.closed}
              >
                {selectedType === "all"
                  ? "+ Record Transaction"
                  : `+ Record ${formatTypeLabel(selectedType)}`}
              </Button>
            )}
          </div>
        </div>

        {/* Filters */}
        <div className="mb-3">
          <DynamicFilters
            type={selectedType}
            values={this.buildAdditionalWhere(additionalFilter)}
            onChange={(f) =>
              this.setAsyncState({
                additionalFilter: { ...additionalFilter, ...f },
                triggerReload: Date.now(),
              })
            }
            agents={this.props.agents}
          />
        </div>

        {/* Tabs */}
        <Nav
          variant="tabs"
          activeKey={selectedType}
          onSelect={(key) => this.handleTypeChange(key)}
          className="mb-3"
        >
          <Nav.Item key="all">
            <Nav.Link eventKey="all">All</Nav.Link>
          </Nav.Item>
          {TRANSACTION_TYPES.map((t) => (
            <Nav.Item key={t.id}>
              <Nav.Link eventKey={t.id}>{t.label}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {/* Transactions List */}
        <ItemList
          defaultQuery={{
            populate: "relatedUser office headOffice",
            limit: 50,
            order: -1,
          }}
          query={this.state.query}
          additionalQueries={{
            ...(this.additionalQueries || {}),
            where: {
              ...(this.additionalQueries?.where || {}),
              ...(this.buildAdditionalWhere(additionalFilter) || {}),
            },
          }}
          triggerReload={triggerReload}
          items={this.getItems()}
          table={{
            rowConfig: ROW_CONFIG,
            columns: columns,
            onRowClick: ({ item, index }) =>
              this.setAsyncState({
                visibleModal: "transactionDetails",
                modalData: { transaction: item, index },
              }),
          }}
          retriveData={this.retriveData.bind(this)}
          setItems={this.setItems.bind(this)}
          scrollSelector={this.props.scrollSelector}
        />

        {/* Record Transaction Modal */}
        <RecordTransaction
          {...{
            key: `recordTransaction-${
              visibleModal === "recordTransaction"
                ? modalData?.transaction?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "recordTransaction",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewTransaction(item),
            account: this.props.account,
            ...(modalData || {}),
          }}
        />

        {/* Transaction Details Modal */}
        <TransactionDetails
          {...{
            key: `transactionDetails-${
              visibleModal === "transactionDetails"
                ? modalData?.transaction?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "transactionDetails",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            handleEdit: () =>
              this.setAsyncState({ visibleModal: "recordTransaction" }),
            ...(modalData || {}),
            handleDelete: () => this.handleDelete(modalData.transaction),
            user: this.props.user,
          }}
        />
      </div>
    );

    if (this.props.contentOnly) {
      return content;
    }

    return (
      <>
        <NavBar activeLink="/transaction" />
        <Container className="gainner">{content}</Container>
      </>
    );
  }
}

const TransactionsScreen = (props) => {
  return props.user.role === "headOffice" ? (
    <div>
      {/* you said head-office screen will be separate — so show only office screen here */}
      <TransactionsScreenOffice {...props} />
    </div>
  ) : (
    <TransactionsScreenOffice {...props} />
  );
};

const mapStateToProps = (state) => ({
  transactions: state.vState[SCREEN_NAME]?.transactions || [],
  agents: state.vState.AGENTS_SCREEN?.agents,
  user: state.pState.user.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransactionsScreenOffice);
